const mappingTable = {
  A: {
    8: [21, 20, 19, 18, 17, 16, 15, 14],
    6: [13, 12, 11, 10],
    4: [9, 8, 7, 6],
    2: [5, 4, 3, 2, 1],
    0: [0, -1, -2, -3, -4],
    "-2": [-5, -6, -7, -8, -9],
    "-4": [-10, -11, -12],
    "-6": [-13, -14, -15, -16],
    "-8": [-17, -18, -19, -20],
  },
  B: {
    8: [18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8],
    6: [7, 6, 5],
    4: [4, 3],
    2: [2, 1, 0],
    0: [-1, -2, -3],
    "-2": [-4, -5],
    "-4": [-6, -7, -8],
    "-6": [-9, -10, -11],
    "-8": [-12, -13, -14, -15, -16, -17, -18],
  },
  C: {
    8: [20, 15, 11, 10],
    6: [9, 8, 7, 6],
    4: [5, 4, 3, 2],
    2: [1, 0],
    0: [-1, -2, -3, -4, -5],
    "-2": [-6, -7],
    "-4": [-8, -9],
    "-6": [-10, -11, -12, -13],
    "-8": [-14, -15, -16, -17, -18],
  },
  D: {
    8: [17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5],
    6: [4, 3],
    4: [2, 1],
    2: [0, -1, -2],
    0: [-3, -4],
    "-2": [-5, -6, -7],
    "-4": [-8, -9, -10],
    "-6": [-11, -12, -13, -14, -15],
    "-8": [-16, -17, -18, -19, -20, -21, -22],
  },
};

const categoryMapping = {
  A: "D",
  B: "I",
  C: "S",
  D: "C",
};

const discCategories = Object.keys(categoryMapping);

export const calculateResults = (options) => {
  const counts = {
    yes: { A: 0, B: 0, C: 0, D: 0, E: 0 },
    no: { A: 0, B: 0, C: 0, D: 0, E: 0 },
  };

  Object.values(options).forEach((option) => {
    if (option.value === "yes") {
      counts.yes[option.category]++;
    } else if (option.value === "no") {
      counts.no[option.category]++;
    }
  });

  const results = {};
  Object.keys(counts.yes).forEach((category) => {
    results[category] = counts.yes[category] - counts.no[category];
  });

  //! Manipulate results here
  // results.A = -3;
  // results.B = -1;
  // results.C = 5;
  // results.D = 2;

  return { counts, results };
};

export const determinePersonality = (results = {}) => {
  const discResults = discCategories
    .map((category) => {
      const rawValue = results[category];
      const value =
        typeof rawValue === "number" ? rawValue : Number.parseInt(rawValue, 10);

      return {
        category,
        value,
      };
    })
    .filter(({ value }) => !Number.isNaN(value));

  if (!discResults.length) {
    return null;
  }

  const maxResult = Math.max(...discResults.map(({ value }) => value));
  const maxCategories = discResults.filter(({ value }) => value === maxResult);

  let bestCandidate = null;

  maxCategories.forEach(({ category, value }) => {
    const mapping = mappingTable[category];

    if (!mapping) {
      return;
    }

    const matchedScoreKey = Object.keys(mapping)
      .sort((left, right) => Number(right) - Number(left))
      .find((scoreKey) => mapping[scoreKey].includes(value));

    if (!matchedScoreKey) {
      return;
    }

    const matchedScore = Number(matchedScoreKey);
    const maxMappedValue = Math.max(...mapping[matchedScoreKey]);
    const categoryPosition = discCategories.indexOf(category);

    if (
      !bestCandidate ||
      matchedScore > bestCandidate.matchedScore ||
      (matchedScore === bestCandidate.matchedScore &&
        maxMappedValue > bestCandidate.maxMappedValue) ||
      (matchedScore === bestCandidate.matchedScore &&
        maxMappedValue === bestCandidate.maxMappedValue &&
        categoryPosition < bestCandidate.categoryPosition)
    ) {
      bestCandidate = {
        matchedScore,
        maxMappedValue,
        categoryPosition,
        personality: categoryMapping[category],
      };
    }
  });

  if (bestCandidate) {
    return bestCandidate.personality;
  }

  return categoryMapping[maxCategories[0]?.category] || null;
};

//! Tes Fungsi
// const testDeterminePersonality = () => {
//   const options = {
//     1: { category: "C", value: "yes" },
//     2: { category: "C", value: "yes" },
//     3: { category: "D", value: "yes" },
//     4: { category: "C", value: "yes" },
//     5: { category: "C", value: "yes" },
//     6: { category: "C", value: "yes" },
//     7: { category: "D", value: "yes" },
//     8: { category: "D", value: "yes" },
//   };

//   const { counts, results } = calculateResults(options);
//   const personality = determinePersonality(results);

//   console.log(`Counts: ${JSON.stringify(counts, null, 2)}`);
//   console.log(`Results: ${JSON.stringify(results, null, 2)}`);
//   console.log(`Kepribadian: ${personality}`);
// };

// testDeterminePersonality();
